export default "{\n    \"emptyPlaceholder\": \"Select a staff member\",\n    \"searchPlaceholder\": \"Search by name\"\n}\n"